import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";

import { ProductReport_productReport_edges_node } from "../../types/ProductReport";

const useStyles = makeStyles(
  theme => ({
    colRow: {
      "& th": {
        fontWeight: 600 as 600,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1)
      }
    },
    table: {
      tableLayout: "fixed"
    }
  }),
  { name: "ProductsReportsList" }
);

interface ProductsReportsListProp extends ListProps {
  products: ProductReport_productReport_edges_node[];
}

const ProductsReportsList: React.FC<ProductsReportsListProp> = ({
  products,
  onNextPage,
  onPreviousPage,
  onUpdateListSettings,
  pageInfo,
  settings,
  disabled
}) => {
  const colNum = 4;
  const classes = useStyles({});

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCellHeader>
              <FormattedMessage defaultMessage=" Product Name" />
            </TableCellHeader>

            <TableCellHeader>
              <FormattedMessage defaultMessage="Order Creation Date" />
            </TableCellHeader>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Order Number" />
            </TableCellHeader>
            <TableCellHeader>
              <FormattedMessage defaultMessage="Tenant Email Address" />
            </TableCellHeader>
          </TableRow>
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={colNum}
              settings={settings}
              hasNextPage={
                pageInfo && !disabled ? pageInfo.hasNextPage : undefined
              }
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : undefined
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {products &&
            renderCollection(
              products,
              (product, index) => (
                <TableRow hover={!!product} key={product ? index : "skeleton"}>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => product.product_name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    <Moment format="MM/DD/YYYY" tz="Asia/Manila">
                      {product?.order_date ? product.order_date : <Skeleton />}
                    </Moment>
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => product.order_id,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    <Skeleton />
                  </TableCell>
                </TableRow>
              ),
              () => (
                <TableRow>
                  <TableCell colSpan={colNum}>
                    <FormattedMessage defaultMessage="No products found" />
                  </TableCell>
                </TableRow>
              )
            )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default ProductsReportsList;
